<template>
  <nav class="lgNav" v-if="!isMobile">
    <router-link to="/" id="logo"
      ><img class="logoImg" src="@/assets/logo.png"
    /></router-link>
    <ul>
      <li>
        <router-link to="/">Inicio</router-link>
      </li>
      <li>
        <router-link to="/projects/one" :class="{ projectRoute: isProject }"
          >Proyectos</router-link
        >
      </li>
      <li>
        <router-link to="/about">Sobre mi</router-link>
      </li>
      <li>
        <router-link to="/contact">Contacto</router-link>
      </li>
    </ul>
  </nav>
  <nav v-else>
    <router-link to="/" id="logo"
      ><img class="logoImg" src="@/assets/logo.png"
    /></router-link>
    <button
      class="hamburger"
      @click="handleClickMenu"
      :class="{ opened: isMenuOpen }"
    >
      <div></div>
    </button>
    <div class="menu" :class="{ opened: isMenuOpen }">
      <ul>
        <li><router-link to="/">Inicio</router-link></li>
        <li>
          <router-link to="/projects/one" :class="{ projectRoute: isProject }"
            >Proyectos</router-link
          >
        </li>
        <li><router-link to="/about">Sobre mi</router-link></li>
        <li><router-link to="/contact">Contacto</router-link></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "TheNav",
  data: function() {
    return {
      isMobile: false,
      isMenuOpen: false,
    };
  },
  created() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  computed: {
    isProject() {
      return this.$route.path.includes("/projects/");
    },
  },
  methods: {
    checkScreenSize() {
      this.isMobile =
        document.documentElement.clientWidth <= 760 ? true : false;
    },
    handleClickMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.isMenuOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  display: grid;
  grid-template-columns: 100px auto;
  align-items: center;
  grid-template-areas: "logo nav";
  background-color: rgba(white, 0.9);
  position: fixed;
  z-index: 4;
  width: 100%;

  #logo {
    grid-area: logo;
    padding: 10px 20px;
    z-index: 999;
  }
  li {
    a {
      color: #000;
      font-size: 0.9em;
      text-transform: uppercase;
      padding: 8px 0px;
      margin: 0 15px;
      position: relative;
      font-weight: bold;
    }

    a:after {
      background: none repeat scroll 0 0 transparent;
      bottom: 0;
      content: "";
      display: block;
      height: 2px;
      left: 50%;
      position: absolute;
      background: #f44647;
      transition: width 0.3s ease 0s, left 0.3s ease 0s;
      width: 0;
    }
    a:hover:after,
    .router-link-exact-active:after,
    .projectRoute:after {
      width: 100%;
      left: 0;
    }
  }
}
.lgNav {
  ul {
    grid-area: nav;
    list-style-type: none;
    justify-self: right;
    margin: 10px 25px;
    font-family: "Space Mono", monospace;
    letter-spacing: 0.3px;

    @media screen and (max-width: 760px) {
      margin: auto;
      padding: 0;
    }
    li {
      display: inline;
    }
  }
}

.hamburger {
  position: absolute;
  top: 6px;
  right: 10px;
  z-index: 2;
  width: 60px;
  height: 60px;
  padding: 1rem;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;

  & > div {
    position: relative;
    flex: none;
    width: 100%;
    height: 2px;
    background: #232323;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.4s ease;

    &::before,
    &::after {
      content: "";
      position: absolute;
      z-index: 2;
      top: -10px;
      width: 100%;
      height: 2px;
      background: inherit;
    }
    &::after {
      top: 10px;
    }
  }
}
.hamburger.opened {
  & > div {
    transform: rotate(135deg);
    background-color: #f44647;

    &::before,
    &::after {
      top: 0;
      transform: rotate(90deg);
      background-color: #f44647;
    }
  }

  & > div,
  & > div::after,
  & > div::before {
    background-color: black;
  }
}

.menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  visibility: hidden;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  ul {
    background: rgba(white, 0.95);
    width: 200vw;
    height: 200vh;
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
    border-radius: 50%;
    flex: none;
    align-items: center;
    justify-content: center;
    transform: scale(0);
    transition: all 0.4s ease;

    li {
      padding: 15px;
      opacity: 0;
      transition: all 0.4s ease;
    }
  }
}
.menu.opened {
  visibility: visible;

  ul {
    transform: scale(1.2);
    transition-duration: 0.75s;

    li {
      opacity: 1;
    }
  }
}
</style>
